<template>

    <Page>

        <div  class="grid grid-cols-2 gap-16 items-start">
            <div>
                <h2 class="mb-4 font-semibold text-lg">Australian Consumer Law (ACL)</h2>
                <ul class="mt-3 list-disc pl-6 font-normal text-white/80">
                    <li>Clearly inform consumers of the program's features, limitations, and exclusions</li>
                    <li>Ensure no misleading or deceptive conduct in advertising or sales practices</li>
                    <li>Provide clear Terms and Conditions and comply with cooling-off period requirements (14 days)</li>
                </ul>

                <h2 class="mt-12 mb-4 font-semibold text-lg">Financial Services Compliance</h2>
                <ul class="mt-3 list-disc pl-6 font-normal text-white/80">
                    <li>While Carbucks PROTECT is not an insurance product, it must comply with disclosure standards akin to financial services</li>
                    <li>Transparency in pricing and fees</li>
                    <li>Proper explanation of coverage and exclusions (e.g., limited number of Work Orders, usage restrictions)</li>
                    <li>Availability of pro-rata refunds under specified circumstances</li>
                </ul>
            </div>
            
            <div>
                <h2 class="mb-4 font-semibold text-lg">Fair Trading and Ethical Sales Practices</h2>
                <ul class="mt-3 list-disc pl-6 font-normal text-white/80">
                    <li>At all times prohibit the use of high pressure sales tactics.  The customer must be free to make up their own mind.</li>
                    <li>Offer Carbucks PROTECT as an optional plan at the time of vehicle purchase or within 30 days of delivery</li>
                    <li>Train F&amp;I Managers to assess customer needs and recommend the program appropriately</li>
                </ul>

                <h2 class="mt-12 mb-4 font-semibold text-lg">Privacy and Data Protection</h2>
                <ul class="mt-3 list-disc pl-6 font-normal text-white/80">
                    <li>Collect, use, and store personal information in accordance with the Privacy Act 1988 and Australian Privacy Principles</li>
                    <li>Inform customers of how their data will be used and provide access to the company's Privacy Policy</li>
                </ul>
            </div>
        </div>

    </Page>

</template>